import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  alertApiRef,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { toastApiRef } from '@backstage/frontend-plugin-api';
import { ArgoCDApiClient, argoCDApiRef } from '@roadiehq/backstage-plugin-argo-cd';
import { sonarQubeApiRef } from '@backstage-community/plugin-sonarqube-react';
import { SonarQubeClient } from '@backstage-community/plugin-sonarqube';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: argoCDApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      identityApi: identityApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, identityApi, configApi }) =>
      new ArgoCDApiClient({
        discoveryApi,
        identityApi,
        backendBaseUrl:
          configApi.getOptionalString('argocd.baseUrl') ?? 'https://argocd.satsure.co',
        searchInstances: true,
        useNamespacedApps: configApi.getOptionalBoolean('argocd.namespacedApps') ?? false,
      }),
  }),
  createApiFactory({
    api: sonarQubeApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new SonarQubeClient({
        discoveryApi,
        fetchApi,
      }),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => ({
      post: ({ title, status }: { title: any; status?: string }) => {
        alertApi.post({
          message: String(title),
          severity: status === 'danger' ? 'error' : (status as any) ?? 'info',
          display: 'transient',
        });
        return { close: () => {} };
      },
    }),
  }),
];
